module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.4d88404.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Medium.ttf
// module id = BEBZ
// module chunks = 10